import { HanaFloatingChatLazy } from '@crehana/hana-ai/floating-chat';
import { App, MyAppProps } from '@crehana/next';

import 'nprogress/nprogress.css';
import '@crehana/next/dist/main.css';
import '../../styles/crehana.tailwindcss.css';
import '@crehana/ui/dist/crehana-ui.min.css';

const CustomApp: React.FC<React.PropsWithChildren<MyAppProps>> = props => {
  return (
    <App
      {...props}
      pageProps={{
        ...props.pageProps,
        disabledShoppingCart: true,
      }}
      customRender={({ Component }) => {
        return (
          <>
            <Component
              err={props.err}
              {...{ ...props.pageProps, disabledShoppingCart: true }}
            />
            <HanaFloatingChatLazy />
          </>
        );
      }}
    />
  );
};

export default CustomApp;
